import React from 'react';
import { IoLocationOutline, IoTimeOutline, IoCalendarOutline,
         IoPeopleOutline, IoRestaurantOutline } from 'react-icons/io5';
import MeetingStatusIndicator from './MeetingStatusIndicator';

const MeetingContainer = ({
    title,
    imageId,
    imageUrl,
    location,
    currentMembers,
    maxMembers,
    time,
    date,
    status,
    onClick
}) => {
    return (
        <div
            onClick={onClick}
            className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer"
        >
            <div className="flex">
            {/* 이미지 */}
            <div className="mr-4">
                {imageId ? (
                    <img
                        src={imageUrl}
                        alt={title}
                        className="w-24 h-24 rounded-lg object-cover"
                    />
                ) : (
                    <div className="w-24 h-24 rounded-lg bg-gray-200 flex items-center justify-center">
                        <IoRestaurantOutline size={32} className="text-gray-400" />
                    </div>
                )}
            </div>

            {/* 콘텐츠 */}
            <div className="flex-1 flex flex-col justify-between min-w-0">
                {/* 상단: 제목 및 상태 */}
                <div className="flex items-start justify-between mb-2">
                    <h3 className="text-sm font-semibold text-gray-900 truncate mr-2 flex-1">
                        {title}
                    </h3>
                    <MeetingStatusIndicator status={status} />
                </div>

                {/* 하단: 정보 */}
                <div className="space-y-1">
                    {/* 인원 */}
                    <div className="flex items-center text-gray-500">
                        <IoPeopleOutline size={14} />
                        <span className="ml-1 text-xs">
                            {currentMembers}/{maxMembers}
                        </span>
                    </div>

                    {/* 날짜 및 시간 */}
                    <div className="flex items-center text-gray-500 space-x-3">
                        {date && (
                            <div className="flex items-center">
                                <IoCalendarOutline size={14} />
                                <span className="ml-1 text-xs">{date}</span>
                            </div>
                        )}
                        {time && (
                            <div className="flex items-center">
                                <IoTimeOutline size={14} />
                                <span className="ml-1 text-xs">{time}</span>
                            </div>
                        )}
                    </div>

                    {/* 위치 */}
                    {location && (
                        <div className="flex items-center text-gray-500">
                            <IoLocationOutline size={14} />
                            <span className="ml-1 text-xs truncate">{location}</span>
                        </div>
                    )}
                </div>
            </div>
            </div>
        </div>
    );
};

export default MeetingContainer;
